/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivFleetInvoiceControllerGetAllParamsGen,
  MrfiktivInvoicePopulatedViewModelGen,
  MrfiktivInvoiceViewModelGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class FleetInvoices<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Invoices
   * @name FleetInvoiceControllerGetAll
   * @summary (FLEET-INVOICE-READ) Get all invoices
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/invoice
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivInvoiceViewModelGen)[] })`
   */
  fleetInvoiceControllerGetAll = (
    { partnerId, fleetId, ...query }: MrfiktivFleetInvoiceControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivInvoiceViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/invoice`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Invoices
   * @name FleetInvoiceControllerGetOne
   * @summary (FLEET-INVOICE-READ) Get a invoice by invoiceId
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/invoice/{invoiceId}
   * @secure
   * @response `201` `MrfiktivInvoicePopulatedViewModelGen` Get an invoice by invoiceId
   */
  fleetInvoiceControllerGetOne = (partnerId: string, fleetId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoicePopulatedViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/invoice/${invoiceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
